import type { TranslationTag } from '@ps/web-core-intl';
import { StarsButton, Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import { CashierFlowType } from '../../../../types/Cashier';
import Container from '../../../Container/Container';

import {
  TXTWCL_Continue,
  TXTWCL_Continue_to_withdraw,
  TXTWCL_Email_verification,
  TXTWCL_Help_with_withdrawals,
  TXTWCL_Just_so_you_know,
  TXTWCL_WeXve_successfully_verified_yo_ELL,
  TXTWCL_YouXre_good_to_go
} from './EmailValidated.messages.json';
import { buttonsWrapper } from './EmailValidated.scss';
import HelpSectionContent from './components/HelpSectionContent';

const translationMapping: Partial<
  Record<CashierFlowType, { title: TranslationTag; button: TranslationTag }>
> = {
  [CashierFlowType.FirstWithdraw]: {
    title: TXTWCL_Help_with_withdrawals,
    button: TXTWCL_Continue_to_withdraw
  },
  [CashierFlowType.FirstP2pTransfer]: { title: TXTWCL_Just_so_you_know, button: TXTWCL_Continue }
};

const EmailValidated: React.FC = () => {
  const {
    data: { cashierFlow }
  } = useWizardContext();

  return (
    <Container
      page={EmailValidated}
      headerProps={{
        title: <Translation {...TXTWCL_Email_verification} />,
        buttons: {}
      }}
      pageTopTitle={<Translation {...TXTWCL_YouXre_good_to_go} />}
      pageTopSubtitle={<Translation {...TXTWCL_WeXve_successfully_verified_yo_ELL} />}
      helpSupportResolver
      helpSection={{
        title: translationMapping[cashierFlow]?.title || TXTWCL_Help_with_withdrawals,
        body: <HelpSectionContent />
      }}
    >
      <div className={buttonsWrapper}>
        <StarsButton
          translation={translationMapping[cashierFlow]?.button || TXTWCL_Continue}
          type="submit"
        />
      </div>
    </Container>
  );
};

EmailValidated.displayName = 'EmailValidated';

export default EmailValidated;
